// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseFareName-module__root___fAp9N"};